import { createContext, useContext, useState, useEffect } from "react";
import type { ReactNode } from "react";

type Role = "distributor" | "retailer" | null;

interface RoleContextType {
  role: Role;
  setRole: (role: Role) => void;
}

const RoleContext = createContext<RoleContextType>({
  role: null,
  setRole: () => {},
});

export const RoleProvider = ({ children }: { children: ReactNode }) => {
  const [role, setRoleState] = useState<Role>(null);

  // Initialize role from localStorage on mount
  useEffect(() => {
    
    const storedRole = sessionStorage.getItem("role");
    
    if (storedRole === "distributor" || storedRole === "retailer") {
      setRoleState(storedRole);
    }
  }, []);

  const setRole = (r: Role) => {
    setRoleState(r);
    if (r) {
      sessionStorage.setItem("role", r);
    } else {
      sessionStorage.removeItem("role");
    }
  };

  return (
    <RoleContext.Provider value={{ role, setRole }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => useContext(RoleContext);
